import { useAppDispatch, useAppSelector } from '@reduxStore';
import { Alert, AlertTitle } from '@mui/material';
import { useEffect, useState } from 'react';
import { clearErrorAnnouncements } from './AnnouncementSlice';
import classNames from 'classnames/bind';

import styles from './Announcement.module.css';
const stylesCtx = classNames.bind(styles);

export default function ErrorAnnouncement() {
	const errors = useAppSelector((state) => state.announcementState.errors);

	const appDispatch = useAppDispatch();

	const [dismiss, setDismiss] = useState(false);

	const handleClose = () => {
		setDismiss(true);
	};

	useEffect(() => {
		if (dismiss) {
			const timeout = setTimeout(() => {
				appDispatch(clearErrorAnnouncements());
				setDismiss(false);
			}, 200);

			return () => {
				clearTimeout(timeout);
			};
		}
	}, [dismiss, appDispatch]);

	if (errors.length < 1) {
		return <></>;
	}

	const alertStyles = stylesCtx({
		announcement: true,
		dismiss: dismiss,
		show: !dismiss,
		straight: true
	});

	return (
		<Alert
			elevation={0}
			severity='error'
			onClose={handleClose}
			className={alertStyles}
			sx={{
				padding: '0px 8px',
				'& .MuiAlert-icon': {
					padding: '5px 0px'
				},
				'& .MuiAlert-message': {
					padding: '6px 0px',
					overflowY: 'hidden',
					width: '100%'
				},
				'& .MuiAlert-action': {
					padding: '2px 0 0 16px',
					marginRight: '0px'
				}
			}}
		>
			{errors.length === 1 ? (
				errors[0].message
			) : (
				<>
					<AlertTitle>Errors:</AlertTitle>
					<ul className={styles['error-list']}>
						{errors.map((err, index) => (
							<li key={`error-${String(index)}`}>{err.message}</li>
						))}
					</ul>
				</>
			)}
		</Alert>
	);
}
